import { dist } from "@/editor/mercator";

// rettangolo a 3 clic: gronda p0→p1, profondità = proiezione del 3° punto sulla normale
export function rect3(p0, p1, m) {
  const L = dist(p0, p1) || 1, ux = (p1[0] - p0[0]) / L, uy = (p1[1] - p0[1]) / L, nx = -uy, ny = ux;
  const d = (m[0] - p1[0]) * nx + (m[1] - p1[1]) * ny;
  return [p0, p1, [p1[0] + nx * d, p1[1] + ny * d], [p0[0] + nx * d, p0[1] + ny * d]];
}

// azimut (Sud = 0°, Ovest = +90°) della falda: perpendicolare alla gronda (1° lato), verso l'esterno
export function gutterAzimuth(pts) {
  const [a, b] = pts, L = dist(a, b) || 1;
  let nx = -(b[1] - a[1]) / L, ny = (b[0] - a[0]) / L;
  const cx = pts.reduce((s, q) => s + q[0], 0) / pts.length, cy = pts.reduce((s, q) => s + q[1], 0) / pts.length;
  if ((cx - a[0]) * nx + (cy - a[1]) * ny > 0) { nx = -nx; ny = -ny; }
  return Math.round((Math.atan2(-nx, -ny) * 1800) / Math.PI) / 10;
}

// azimut se il lato i è la gronda
export const edgeAzimuth = (pts, i) => gutterAzimuth([...pts.slice(i), ...pts.slice(0, i)]);

// Tipo di tetto: rettangolo [p0,p1,p2,p3] (p0→p1 gronda) → falde; il 1° lato di ogni falda è la sua gronda
export function splitRoof(rect, shape, pitch = 30, hipPitch = pitch) {
  const [p0, p1, p2, p3] = rect;
  if (shape !== "sella" && shape !== "padiglione") return [{ key: "main", pts: rect, pitch }];
  const L = dist(p0, p1), D = dist(p1, p2);
  const ux = (p1[0] - p0[0]) / L, uy = (p1[1] - p0[1]) / L;
  const mid = (a, b) => [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
  const m0 = mid(p0, p3), m1 = mid(p1, p2);
  if (shape === "sella") return [{ key: "front", pts: [p0, p1, m1, m0], pitch }, { key: "back", pts: [p2, p3, m0, m1], pitch }];
  const t = (a) => Math.tan((Math.max(1, Math.min(80, a)) * Math.PI) / 180);
  const a = Math.min(L / 2, ((D / 2) * t(pitch)) / t(hipPitch));
  const r0 = [m0[0] + ux * a, m0[1] + uy * a], r1 = [m1[0] - ux * a, m1[1] - uy * a];
  const uniq = (pts) => pts.filter((q, i) => dist(q, pts[(i + 1) % pts.length]) > 1e-6);
  return [
    { key: "front", pts: uniq([p0, p1, r1, r0]), pitch },
    { key: "right", pts: [p1, p2, r1], pitch: hipPitch },
    { key: "back", pts: uniq([p2, p3, r0, r1]), pitch },
    { key: "left", pts: [p3, p0, r0], pitch: hipPitch },
  ];
}

export const rotateAbout = (p, c, a) => {
  const co = Math.cos(a), si = Math.sin(a), x = p[0] - c[0], y = p[1] - c[1];
  return [c[0] + co * x - si * y, c[1] + si * x + co * y];
};
